import React, { useState } from "react";
import { Card, Row, Button, Col, Modal } from "react-bootstrap";
import Simao_Photo from "../../../../assets/icons/Simao_Photo.svg";

const AbsenceList = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAbsence, setSelectedAbsence] = useState(null);

  const [absences, _setAbsences] = useState([
    {
      name: "Simão",
      type: "Férias",
      startDate: "2025-07-01",
      endDate: "2025-07-10",
      description: "Viagem de férias em família",
    },
    {
      name: "Jorge",
      type: "Baixa Média",
      startDate: "2025-06-06",
      endDate: "2025-06-12",
      description: "Motivos médicos",
    },
    {
      name: "Tomas",
      type: "Férias",
      startDate: "2025-06-06",
      endDate: "2025-06-12",
      description: "Viagem pessoal",
    },
  ]);

  const handleShowModal = (absence) => {
    setSelectedAbsence(absence);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAbsence(null);
  };

  const countBusinessDays = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    let count = 0;

    for (
      let d = new Date(startDate);
      d <= endDate;
      d.setDate(d.getDate() + 1)
    ) {
      const day = d.getDay();
      if (day !== 0 && day !== 6) {
        count++;
      }
    }

    return count;
  };

  return (
    <>
      <Card
        style={{ color: "white", backgroundColor: "#121843", height: "25vh" }}
      >
        <Card.Header style={{ color: "white", backgroundColor: "#121843" }}>
          <Row>
            <Col>Ausências</Col>
          </Row>
        </Card.Header>
        <Card.Body>
          {absences.length === 0 ? (
            <p style={{ color: "white" }}>Sem ausências registadas.</p>
          ) : (
            <div
              style={{
                maxHeight: "160px",
                overflowY: "auto",
                paddingRight: "5px",
              }}
            >
              <ul
                style={{
                  paddingLeft: 0,
                  listStyleType: "none",
                  marginBottom: 0,
                }}
              >
                {absences.map((absence, index) => (
                  <li key={index} style={{ marginBottom: "1rem" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={Simao_Photo}
                          alt="user icon"
                          style={{ width: 18, height: 18, marginRight: 8 }}
                        />
                        {absence.name}
                      </div>
                      <span style={{ fontStyle: "italic" }}>
                        {absence.type}
                      </span>
                    </div>
                    <div
                      style={{
                        color: "white",
                        marginLeft: "26px",
                        fontSize: "0.9rem",
                      }}
                    >
                      Vai estar ausente no dia {absence.startDate} a dia{" "}
                      {absence.endDate}
                    </div>
                    <Button
                      variant="primary"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#0d6efd",
                        textDecoration: "none",
                        marginLeft: "26px",
                        padding: 0,
                        fontSize: "0.9rem",
                        boxShadow: "none",
                      }}
                      onClick={() => handleShowModal(absence)}
                    >
                      Visualizar
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "4px",
                height: "24px",
                backgroundColor: "#0d6efd",
                borderRadius: "2px",
              }}
            ></div>
            <h5 className="modal-title mb-0">Detalhes da Ausência</h5>
          </div>
        </Modal.Header>

        <Modal.Body>
          {selectedAbsence && (
            <>
              <p>
                <strong>Nome:</strong> {selectedAbsence.name}
              </p>
              <p>
                <strong>Tipo:</strong> {selectedAbsence.type}
              </p>
              <p>
                <strong>Razão:</strong> {selectedAbsence.description}
              </p>
              <p>
                <strong>Período:</strong> {selectedAbsence.startDate} a{" "}
                {selectedAbsence.endDate}
              </p>
              <p>
                <strong>Total de dias ausente:</strong>{" "}
                {countBusinessDays(
                  selectedAbsence.startDate,
                  selectedAbsence.endDate
                )}
              </p>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AbsenceList;
